export default __webpack_public_path__ + "static/media/darkMapPin.9dfcd8fa.svg";